import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";
import { globalJson } from "global/global_json";
import React, { useEffect, useState } from "react";

function PrivacyPolicyPage() {
  const [content, setContent] = useState([]); // Ensure content is always an array
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent(
          process.env.REACT_APP_ENV !== "prod"
            ? globalJson.dev_company_id
            : globalJson.prod_company_id
        );

        // Ensure data is an array or default to an empty array
        setContent(response.data.privacy_policy);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching content", error);
      }
    };

    getContent();
  }, []);

  // Removed noisy console log
  // console.log(content);

  return (
    <div className=" py-8">
      <div className="mx-auto max-w-3xl">
        <div className="rounded-xl  p-6">
          <div className="mb-8 text-center">
            <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-gray-900">
              Privacy Policy
            </h1>
            <p className="mt-2 text-sm text-gray-500">
              Learn how we collect, use, and protect your information.
            </p>
          </div>
          {loading ? (
            <div className="flex justify-center items-center min-h-[30vh]">
              <div className="animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-400"></div>
            </div>
          ) : (
            <div>
              {content?.length > 0 ? (
                <ol className="space-y-6  pl-6">
                  {content.map((item: any, i: number) => (
                    <li key={i} className="pl-2">
                      <div className="rounded-lg">
                        <div className="px-5 py-2 rounded-t-lg">
                          <h4 className="text-lg font-semibold text-gray-900">
                            {i + 1} . {item?.title}
                          </h4>
                        </div>
                        <div className="p-5">
                          <div
                            className="prose prose-sm md:prose text-gray-700 max-w-none
                                       prose-headings:text-gray-900 prose-p:leading-relaxed
                                       prose-a:text-primary-600 prose-strong:text-gray-900
                                       prose-ul:list-disc prose-ol:list-decimal prose-li:my-1"
                            dangerouslySetInnerHTML={{ __html: item?.content }}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ol>
              ) : (
                <p className="text-center text-gray-500">
                  No content available.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
